export function hasRight(user, moduleName, rightName) {
  if (!user || !user.userrights || user.role === 'admin') {
    // Admins always have access, or if user/userrights are not defined
    return true;
  }

  const moduleRight = user.userrights.find(r => r.module === moduleName);
  if (moduleRight && moduleRight[rightName] === 1) {
    return true;
  }

  return false;
}
